import { APISERVICE } from "@api/RestClient";
import { GuestReferral, GuestReferralInvitePayload, ReferralConfig } from "@type/referral";

export const getReferralConfig = (tenantId: number | string, storeId: number | string): Promise<ReferralConfig> => {
    return new Promise((res, rej) => {
        APISERVICE.GET(
            `${process.env.NEXT_PUBLIC_GET_BASE_CATALOG_URL}/referralConfig?tenantId=${tenantId}&storeId=${storeId}`,
            {}
        )
            .then((response) => {
                if (response.status === 200) {
                    const body = response.data;
                    const config = body?.data && typeof body.data === 'object' && !Array.isArray(body.data)
                        ? body.data
                        : body;
                    res(config as ReferralConfig);
                } else {
                    rej({ error: 'Unable to fetch referral config' });
                }
            })
            .catch((error) => {
                rej({ error: 'Unable to fetch referral config', status: error });
                console.error("error", error);
            });
    });
};

export const getGuestReferralsByGuestId = (guestId: number | string): Promise<GuestReferral[]> => {
    return new Promise((res, rej) => {
        APISERVICE.GET(
            `${process.env.NEXT_PUBLIC_GUEST}/guestReferralInvite?referredByGuestId=${guestId}`,
            {}
        )
            .then((response) => {
                if (response.status === 200) {
                    const referrals = Array.isArray(response.data)
                        ? response.data
                        : Array.isArray(response.data?.data)
                            ? response.data.data
                            : [];

                    res(referrals);
                } else if (response.status === 401) {
                    rej({ error: `API FAILED ==> ${process.env.NEXT_PUBLIC_GUEST}/guestReferralInvite?referredByGuestId=${guestId}`, status: response.status });
                } else {
                    rej({ error: 'Unable to fetch referrals' });
                }
            })
            .catch((error) => {
                rej({ error: 'Unable to fetch referrals', status: error });
                console.error("error", error);
            });
    });
};

export const submitGuestReferralInvites = (payload: GuestReferralInvitePayload[]): Promise<void> => {
    return new Promise((res, rej) => {
        APISERVICE.POST(`${process.env.NEXT_PUBLIC_GUEST}/guestReferralInvite`, payload)
            .then((response) => {
                if (response.status === 200 || response.status === 201) {
                    res();
                } else {
                    rej({ error: 'Unable to send referral invitations' });
                }
            })
            .catch((error) => {
                rej({ error: 'Unable to send referral invitations', status: error });
                console.error("error", error);
            });
    });
};
